import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  collapsed: boolean
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export default function GridGroupHeaderCollapseExpandIcon({ collapsed, onClick }: Props): ReactElement {
  const { t } = useTranslation();

  let title = t('gridGroupHeader.collapseAll');
  let className = 'expanded';

  if (collapsed) {
    title = t('gridGroupHeader.expandAll');
    className = 'collapsed';
  }

  return (
    <span
      data-testid="GridGroupHeaderExpandCollapse"
      className={className}
      onClick={onClick}
      title={title}
      role="presentation"
    >
      <span className="ag-icon ag-icon-contracted" unselectable="on" />
      <span className="ag-icon ag-icon-contracted" unselectable="on" />
    </span>
  );
}
